import { render, staticRenderFns } from "./StorageContainerDrawerConfiguration.vue?vue&type=template&id=6d22c8a2&"
import script from "./StorageContainerDrawerConfiguration.vue?vue&type=script&lang=js&"
export * from "./StorageContainerDrawerConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
